<acc-modal #emailTpl type="input" [action]="action" [config]="config"
           [title]="'email.send.title'|translate"
           (accConfirmed)="sendEmail()"
           (accClosed)="close()"
           (accCanceled)="close()">
  <!-- Recipient-Info (Invoice-Address) START -->
  @if (hasRecipient()) {
    <acc-card>
      <acc-card-body>
        <div [innerHTML]="getRecipient()"></div>
      </acc-card-body>
    </acc-card>
  }
  <!-- Recipient-Info (Invoice-Address) END -->
  <!-- Select/Change Recipient and Select Email from Contact START -->
  @if (currentView === 'email-select') {
    <div>
      @if (emailSelectWrapper && emailSelectWrapper.isReady) {
        <acc-form [wrapper]="emailSelectWrapper">
          <acc-form-contact name="contactId" [wrapper]="emailSelectWrapper"
                            (accChanged)="onEmailSelectContactChanged($event)"/>
          <acc-form-select name="email" [wrapper]="emailSelectWrapper" [config]="emailSelectConfig"/>
          @if (hasContact()) {
            <acc-button size="sm" (accClick)="showContactEmailAdd()">
              <acc-icon name="add"/>
              {{ 'email.address.add'|translate }}
            </acc-button>
          }
        </acc-form>
      }
    </div>
  }
  <!-- Select/Change Recipient and Select Email from Contact END -->
  <!-- Select Email from Contact END -->
  <!-- Add new Email-Address START -->
  @if (currentView === 'email-add') {
    <div>
      @if (emailAddWrapper && emailAddWrapper.isReady) {
        <acc-form [wrapper]="emailAddWrapper">
          <acc-form-contact name="contactId" [wrapper]="emailAddWrapper"/>
          <acc-form-input name="email" [wrapper]="emailAddWrapper"/>
          <div class="d-flex gap-2">
            <acc-button size="sm" [disabled]="emailAddWrapper.isInvalid()"
                        (accClick)="emailAddWrapper.submit()">
              {{ 'email.address.save'|translate }}
            </acc-button>
            <acc-button size="sm" status="danger"
                        (accClick)="showContactEmailSelect()">
              {{ 'cancel'|translate }}
            </acc-button>
          </div>
        </acc-form>
      }
    </div>
  }
  <!-- Add new Email-Address END -->
</acc-modal>
